import './App.css';
import Home from './pages/Home';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Service } from './pages/Service';
import Loader from './pages/Loader';
import Communitypage from './pages/Communitypage';
function App() {
  return (
    <div className="App">
       < Router>
         <Routes>
            <Route path='/' element={<Loader/>} />
            <Route path="/home" element={<Home/>}></Route>
            <Route path="/service" element={<Service/>}></Route>
            <Route path='/community' element={<Communitypage/>}  />
         </Routes>
       </Router>
    </div>
  );
}

export default App;

